module.exports = __webpack_public_path__ + "img/img_presentation_concours_edf_pulse.404fadb4.png";